import '@babel/polyfill';
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import 'quill/dist/quill.core.css'

import 'quill/dist/quill.snow.css'

import 'quill/dist/quill.bubble.css'
import 'swiper/dist/css/swiper.css'

import h5Config from "../../../../utils/h5Config";
import htmlConfig from "../../../../utils/htmlConfig";
import urlConfig from "./url";
import http from '../../../../utils/http';
import "element-ui/lib/theme-chalk/index.css";
import "../../../../../public/font-awesome-4.7.0/css/font-awesome.min.css";
import "../../../../style/yh-color.css";
import "../../../../style/yh-common.css";
import "./style/main.css";
// let vConsole = new Vconsole();
import Antd from "ant-design-vue";
// import 'ant-design-vue/dist/antd.css'
import VDistpicker from "v-distpicker";

Vue.component("v-distpicker", VDistpicker);
Vue.use(Antd)
// 内部修正urlConfig的地址
if (urlConfig) {
  window.urlConfig = urlConfig;
}
Vue.prototype.http = http;
Vue.prototype.urlConfig = urlConfig;
// 设置axios的默认请求地址
// Vue.prototype.axios.defaults.baseURL = window.urlConfig.url;
Vue.prototype.uploadURL = window.urlConfig.file.up;
Vue.prototype.imgUrl = window.urlConfig.imgUrl;
Vue.prototype.pagePer = 16;
// 设置h5 禁止页面缩放
//h5Config.setMeta();
// 禁止页面缓存
// h5Config.setMeta({
//   "http-equiv": "Cache-control",
//   content: "no-cache"
// });
// h5Config.setMeta({
//   "http-equiv": "Cache",
//   content: "no-cache"
// });
// h5Config.setMeta({
//   "http-equiv": "Pragma",
//   content: "no-cache"
// });
// 设置页面的title名字
htmlConfig.setTitle("知识产权服务平台");
Vue.config.productionTip = false;
import AOS from 'aos';
import 'aos/dist/aos.css'; 
AOS.init({
	once:true,
	duration:500,
	easing:'ease-in-out'
});

Vue.use(ElementUI);

// Vue.use(VueLazyLoad, {
//   error: require('./assets/logo.png'),
//   loading: require('./assets/logo.png')
// })
// Vue.use(Swiper);
window.VUE = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
